
// Vuetify's ENCLOSED variants. `VTextField` derives its own
// `v-text-field--enclosed` class as `filled || solo || solo-inverted ||
// outlined`, and that is exactly the set whose top spacing differs — see
// `spacingClass`.
const ENCLOSED_ATTRS = ["outlined", "filled", "solo", "solo-inverted"];

// A Vuetify boolean prop passed as a bare attribute arrives as `""`; bound to
// an expression it arrives as the value itself. Only `undefined`/`null`/`false`
// mean "not this variant" — `""` means the attribute is present.
function isAttrSet(value) {
  return value !== undefined && value !== null && value !== false;
}

export default {
  // So `error-messages`, `placeholder`, `autocomplete` etc. land on the
  // inner control rather than on the wrapper div.
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    textarea: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Vuetify reserves 16px above the box for the floating label:
    //
    //   .v-text-field { padding-top: 12px; margin-top: 4px }
    //
    // and `mt-n4` gives exactly that back, because this component renders its
    // label detached and passes `label: ""`. But the reservation only exists on
    // the DEFAULT (underlined) variant — every enclosed variant zeroes it:
    //
    //   .v-text-field.v-text-field--enclosed { margin: 0; padding: 0 }
    //
    // so applying `mt-n4` there subtracts space that was never added and drags
    // the box a full 16px up, striking its top border through the detached
    // label. That was the Send Invoice dialog's two `outlined` fields.
    //
    // The app's own boxed-input rule in `_foundation.scss` § 6 restyles the
    // default variant to look outlined, so passing `outlined` here is usually
    // the wrong call anyway — but it must not break the layout when it happens.
    spacingClass() {
      return this.isEnclosed ? null : "mt-n4";
    },
    isEnclosed() {
      return ENCLOSED_ATTRS.some((name) => isAttrSet(this.$attrs[name]));
    },
  },
};
